<div class="info">
  <button
    mat-mini-fab
    color="accent"
    class="info-btn"
    (click)="handleOpenBloggerClick()"
  >
    <mat-icon class="icon">account_circle</mat-icon>
  </button>
  <div class="info-description">
    <p class="info-description-text">
      <span>
        {{ bloggerData().id }}
      </span>
      <span class="info-description-username">
        {{ bloggerData()['username'] }}
      </span>
    </p>
    <p class="info-description-url">
      {{ bloggerData()['url'] }}
    </p>
  </div>
</div>
